import { makeAutoObservable } from 'mobx';
import UserModel from './UserModel';

class MessageModel {
  id = 0;

  conversation_id = 1;

  account_id = 1;

  token = '';

  messageTimestamp = null;

  track_id = null;

  messageType = 1;

  message = {}; // {"text":"Книги"}",

  created_at = null;

  updated_at = null;

  deleted_at = null;

  status = 0;

  sender = 0;

  sender_account = {};

  seenTime = 0;

  deliverTime = 0;

  fullMessage = {};

  constructor(message, autoObservable = true) {
    if (message) {
      this.id = message.id;
      this.conversation_id = message.conversation_id;
      this.account_id = message.account_id;
      this.token = message.token;
      this.messageTimestamp = new Date(message.messageTimestamp);
      this.track_id = message.track_id;
      this.messageType = message.messageType;
      const msg = JSON.parse(message.message);
      this.message = msg.text;
      this.fullMessage = msg;
      this.created_at = new Date(message.created_at);
      this.updated_at = new Date(message.updated_at);
      this.deleted_at = new Date(message.deleted_at);
      this.status = message.status;
      this.sender = message.sender;
      this.sender_account = new UserModel(message.sender_account, autoObservable);
      this.seenTime = message.seenTime;
      this.deliverTime = message.deliverTime;
    }
    if (autoObservable) {
      makeAutoObservable(this);
    }
  }
}

export default MessageModel;
